import ID_ICON from "@/assets/icons/ID.svg";
import { ReactComponent as ARROW_RIGHT } from "@/assets/icons/arrow-right.svg";
import "./style.scss";
import { User } from "@/@core/entity/user.entity";
import { FC } from "react";
import { stringToDate } from "@/utils/date";
import { useLocation } from "react-router-dom";

interface InformationTabProps {
  user: User | undefined;
}

const InformationTab: FC<InformationTabProps> = ({ user }) => {
  const location = useLocation();
  const { state } = location;
  const { isShowActivityInfo, showBio } = state;

  return (
    <div className="information-tab-wrapper">
      <div className="infomation-tab-item">
        <div className="left-section">
          <label className="left-section-label">Personal info</label>
          <span className="desc">User personal details.</span>
        </div>
        <div className="right-section" style={{ display: "block" }}>
          {user?.bio && showBio && <span className="bio">{user.bio}</span>}
          <div className="blue-wrapper">
            <div
              style={{
                display: "block",
              }}
            >
              <div className="content-wrapper" style={{ marginBottom: "32px" }}>
                <label className="right-label">Date of Birth</label>
                <span className="value">
                  {stringToDate(String(user?.date_of_birth), "dd month yyyy")}
                </span>
              </div>

              <div className="content-wrapper">
                <label className="right-label">Location</label>
                <div className="flex-container">
                  <img
                    src={ID_ICON}
                    alt="id-flag"
                    style={{ marginRight: "8px" }}
                  />
                  <span className="value">Indonesia</span>
                </div>
              </div>
            </div>

            <div style={{ display: "block" }}>
              <div className="content-wrapper" style={{ marginBottom: "32px" }}>
                <label className="right-label">Phone</label>
                <div className="flex-container">
                  <span className="value" style={{ color: "#175CD3" }}>
                    {user?.phone_number || "-"}
                  </span>
                  <div className="arrow-wrapper">
                    <ARROW_RIGHT />
                  </div>
                </div>
              </div>

              <div className="content-wrapper">
                <label className="right-label">Email</label>
                <div className="flex-container">
                  <span className="value" style={{ color: "#175CD3" }}>
                    {user?.email || "-"}
                  </span>
                  <div className="arrow-wrapper">
                    <ARROW_RIGHT />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="infomation-tab-item">
        <div className="left-section">
          <label className="left-section-label">Product info</label>
          <span className="desc">User personal details.</span>
        </div>
        <div className="right-section">
          <div className="content-wrapper">
            <label className="right-label">Product Claim</label>
            <div className="flex-container">
              <span className="value" style={{ color: "#175CD3" }}>
                {user?.total_claim}
              </span>
              <div className="arrow-wrapper">
                <ARROW_RIGHT />
              </div>
            </div>
          </div>

          <div className="content-wrapper">
            <label className="right-label">Product Transfered</label>
            <div className="flex-container">
              <span className="value" style={{ color: "#175CD3" }}>
                {user?.total_transfer}
              </span>
              <div className="arrow-wrapper">
                <ARROW_RIGHT />
              </div>
            </div>
          </div>
        </div>
      </div>

      {isShowActivityInfo && (
        <div className="infomation-tab-item">
          <div className="left-section">
            <label className="left-section-label">Activity info</label>
            <span className="desc">User activity.</span>
          </div>
          <div className="right-section">
            <div className="content-wrapper">
              <label className="right-label">Last Active</label>
              <span className="value">-</span>
            </div>

            <div className="content-wrapper">
              <label className="right-label">Last Active Location</label>
              <div className="flex-container">
                <img
                  src={ID_ICON}
                  alt="id-flag"
                  style={{ marginRight: "8px" }}
                />
                <span className="value">Indonesia</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InformationTab;
